import { number, object, string } from 'yup';
import { getMaxError, getMinError, getRequireError } from '../../../utils/get-yup-errors';

export const createFileValidationSchema = object().shape({
    description: string().notRequired().max(255, getMaxError(255, 'Description')),
});
